import _ from 'lodash';
import L from 'leaflet';
import {DICTIONARY} from '../../dictionary';
import {RouteService} from '../../services/routeService';
import {InboundTrendsService} from '../../services/inboundTrendsService';
import {OutboundTrendsService} from '../../services/outboundTrendsService';
import {NotificationService} from '../../services/notificationService';
import {GeneralService} from '../../services/generalService';
import {Component, OnInit, ViewChild} from "@angular/core";
import {ChartComponent} from "ng-apexcharts";
import {Router} from "@angular/router";
import {QuickAccessService} from "../../services/quickAccessService";
// CC: taken from quarantined-email-action.component.ts -> moment import
import moment from "moment/moment";


@Component({
	selector: 'home-component',
	templateUrl: './home.component.html',
})
export class HomeComponent implements OnInit {

    constructor(private rs:RouteService,
				private inboundTrendsService:InboundTrendsService,
				private outboundTrendsService:OutboundTrendsService,
				private router:Router,
				public gs:GeneralService,
				private ns:NotificationService,
				private quickAccessService: QuickAccessService) {
    }

	@ViewChild('inboundTrendsChart', {static: false}) inboundTrendsChart: ChartComponent;
	@ViewChild('threatDetectionTypeChart', {static: false}) threatDetectionTypeChart: ChartComponent;
	@ViewChild('outboundEmailsChart', {static: false}) outboundEmailsChart: ChartComponent;
	@ViewChild('emailTraceChart', {static: false}) emailTraceChart: ChartComponent;
	@ViewChild('outboundRulesChart', {static: false}) outboundRulesChart: ChartComponent;

	dic = DICTIONARY;
    corpname = this.gs.corpname;
    isLF = true;
    getInboundStatsInProcess;
	batchSize = this.gs.isProductionEnv() ? 3000 : 10;
	batchInProcess
	abortLoadingFlag: boolean;
	showAbortLoadingEmailsLabel: boolean;
    getOutboundStatsInProcess;
	getEmailTraceStatsInProcess;
    getGeneralDataInProcess;
    getCompromisedStatsInProcess;
    userInfo;
    isAdmin;
	emailTraceEmails;
    usageData;
	emailTraceLastActivity;
    storageLeft;
    isExpiredSoon;
    usersMeterChartOptions;
    mailboxesMeterChartOptions;
    maxStorageCapacity;
    totalStorageUsage;
    storageUsageBarOptions;
    outboundTrendsChartOptions;
	emailTraceTrendsChartOptions;
	outboundRulesChartOptions;
    compromisedIncidentsChartOptions;
    compromisedLocations;
    compromisedLayers;
    inboundTrendsChartOptions;
    detectionTypeChartOptions;
    ruleUsagePopupData;
	showLatestNotificationssMenu;
	leafletCenter = {
		last: {lat: 0, lng: 0, zoom: 2}
	};

    dashboardPeriod = [
		this.dic.CONSTANTS.trendsPeriod.lastDay,
		this.dic.CONSTANTS.trendsPeriod.last3Days,
        this.dic.CONSTANTS.trendsPeriod.lastWeek,
        this.dic.CONSTANTS.trendsPeriod.lastMonth
    ];
    period = this.dashboardPeriod[1];
	private inboundEmails: any;
	private outboundEmails: any;
	quickAccessPages: any;

	ngOnInit() {
        this.gs.getUserInfo(false, userInfo => {
            this.userInfo = userInfo;
            this.isAdmin = this.userInfo.user_role === this.dic.CONSTANTS.userRole.admin || this.userInfo.user_role === this.dic.CONSTANTS.userRole.subAdmin;
            this.isLF = userInfo.plan.customization?.lf?.enabled;
            if (this.isLF && userInfo.plan.customization?.lf?.company) {
                this.corpname = userInfo.plan.customization.lf.company;
            }

			if (this.isAdmin) {
				this.getEmailTraceStats();
			}
        });

        this.usageData = {};

		this.abortLoadingFlag = false;

		this.quickAccessPages = this.quickAccessService.getQuickAccessPages();

        this.getGeneralUsageData(this.period);

        this.getOutboundStats(false);

        this.getInboundStats(false);

        this.getAccountCompromisedStats(this.period);
    }

	ngOnDestroy(): void {
		this.abortLoadingFlag = true;
	}

    changePeriod(periodObj) {
        if (this.period.value === periodObj.value) {
            return;
        }
        this.period = periodObj;

		this.abortLoadingFlag = false;

		this.getGeneralUsageData(periodObj);
        this.getOutboundStats(false);
        this.getInboundStats(false);
        this.getAccountCompromisedStats(periodObj);

		if (this.isAdmin) {
			this.getEmailTraceStats();
		}
    }

	getUsage(params, cb) {
		if (this.userInfo.user_role === this.dic.CONSTANTS.userRole.admin || this.userInfo.user_role === this.dic.CONSTANTS.userRole.subAdmin) {
			this.rs.getAdminUsage(params).then(usageData => {
				cb(null, usageData);
			}, (err) => {
				cb(err);
			});
		}
		else {
			this.rs.getUsage(params).then(usageData => {
				cb(null, usageData);
			}, (err) => {
				cb(err);
			});
		}
	}

    getGeneralUsageData(periodObj) {
        this.getGeneralDataInProcess = true;
		const params = {type: this.dic.CONSTANTS.dashboardTypes.general, period: periodObj.value};
		this.getUsage(params, (err, usageData) => {
			if (err) {
				this.getGeneralDataInProcess = false;
				return;
			}
			this.usageData.general = usageData;
            if (this.isAdmin) {
                this.storageLeft = this.usageData.general.planInfo.storage - (this.usageData.general.planInfo.attachments_overall_size || 0);
                this.isExpiredSoon = this.gs.dateDiffInDays(new Date(this.usageData.general.planInfo.expired), new Date()) < 7;

                // users usage meter chart
                const usedUsersRatio = Math.round(this.usageData.general.planInfo.shared_plan.used_users / this.usageData.general.planInfo.shared_plan.allowed_users * 100);
                const usersBgColor = usedUsersRatio > 90 ? '#d9355a' : usedUsersRatio > 70 ? '#e6cd4f' : '#006400'; // (#006400 = darkgreen)
                this.usersMeterChartOptions = {
                    series: [usedUsersRatio],
                    chart: {
                        type: 'radialBar',
                    },
                    plotOptions: {
                        radialBar: {
                            startAngle: -90,
                            endAngle: 90,
                            track: {
                                background: "#e7e7e7",
                                strokeWidth: '97%',
                                margin: 5, // margin is in pixels
                            },
                            dataLabels: {
                                name: {
                                    show: false
                                },
                                value: {
                                    offsetY: -12,
                                    fontSize: '100%'
                                }
                            }
                        }
                    },
                    colors: [usersBgColor],

                    labels: ['Users'],
                };

                // mailboxes usage meter chart
                const usedMailboxesRatio = Math.round(this.usageData.general.planInfo.threat_protection.used_users / this.usageData.general.planInfo.threat_protection.allowed_users * 100);
                const mailboxesBgColor = usedMailboxesRatio > 90 ? '#d9355a' : usedMailboxesRatio > 70 ? '#e6cd4f' : '#006400'; // (#006400 = darkgreen)
                this.mailboxesMeterChartOptions = {
                    series: [usedMailboxesRatio],
                    chart: {
                        type: 'radialBar',
                    },
                    plotOptions: {
                        radialBar: {
                            startAngle: -90,
                            endAngle: 90,
                            track: {
                                background: "#e7e7e7",
                                strokeWidth: '97%',
                                margin: 5, // margin is in pixels
                            },
                            dataLabels: {
                                name: {
                                    show: false
                                },
                                value: {
                                    offsetY: -12,
                                    fontSize: '100%'
                                }
                            }
                        }
                    },
                    colors: [mailboxesBgColor],

                    labels: ['Users'],
                };

                // usage by category bar
                this.getStorageUsageChaOptions();
            }
            else {
                if (this.usageData.general.notifications.length > 4) {
                    this.usageData.general.notifications = this.usageData.general.notifications.slice(this.usageData.general.notifications.length - 4, this.usageData.general.notifications.length);
                }
                this.usageData.general.notifications = this.ns.parseNotificationsUI(this.usageData.general.notifications);

                if (this.usageData.general.emailsSentOpenStats && this.usageData.general.emailsSentOpenStats.data && this.usageData.general.emailsSentOpenStats.data.length) {
                    this.usageData.general.emailsSentOpenStats['sent'] = this.usageData.general.emailsSentOpenStats.data[this.usageData.general.emailsSentOpenStats.labels.indexOf('Sent')];
                    this.usageData.general.emailsSentOpenStats['opened'] = this.usageData.general.emailsSentOpenStats.data[this.usageData.general.emailsSentOpenStats.labels.indexOf('Opened')];
                }

            }

            this.getGeneralDataInProcess = false;
        });
    }

    getStorageUsageChaOptions() {
        if (!this.usageData.general.planInfo.usage) {
            this.usageData.general.planInfo.usage = {};
        }
        // usage by category bar
        const series = [
            {name: 'Archived Emails', color: '#e0af00', data: [(this.usageData.general.planInfo.usage.archive || 0) * this.dic.CONSTANTS.usageStorageMultipliers.archive * 1024]},
            {name: 'Sent Attachments', color: '#34383f', data: [(this.usageData.general.planInfo.usage.attachments || 0) * this.dic.CONSTANTS.usageStorageMultipliers.attachments * 1024]},
            {name: 'Sent Emails', color: '#cb3e00', data: [(this.usageData.general.planInfo.usage.emails || 0) * this.dic.CONSTANTS.usageStorageMultipliers.emails * 1024]},
            {name: 'Inbound Quarantine', color: '#8300ec', data: [(this.usageData.general.planInfo.usage.quarantines || 0) * this.dic.CONSTANTS.usageStorageMultipliers.quarantines * 1024]},
        ];

        const userTotalCapacityBytes = this.dic.CONSTANTS.usageStorageMultipliers.userTotalCapacity * 1024 * 1024 * 1024;
        this.maxStorageCapacity = Math.max(this.usageData.general.planInfo.threat_protection.allowed_users, this.usageData.general.planInfo.shared_plan.allowed_users) * userTotalCapacityBytes;
		if (this.userInfo.plan._id.toString() === '67618dc04ba9a3c45953f06d') {
			this.maxStorageCapacity = 615 * userTotalCapacityBytes;
		}
		if (this.userInfo.plan._id.toString() === '650cc08cd74b1462095f319b') {
			this.maxStorageCapacity = 50 * 1024 * 1024 * 1024 * 1024;
		}
        this.totalStorageUsage = _.sum(_.map(series, value => value.data[0]));

        this.storageUsageBarOptions = {
            series: series,
            chart: {
                type: 'bar',
                height: '100%',
                stacked: true,
                toolbar: {
                    show: false
                },
                legend: {
                    tooltip: {
                        enabled: true,
                    }
                }
            },
            grid: {
                show: false
            },
            plotOptions: {
                bar: {
                    horizontal: true,
                    barHeight: '100%',
                    colors: {
                        backgroundBarColors: ['#bdbdbd']
                    }
                },
            },
            colors: _.map(series, 'color'),
            dataLabels: {
                enabled: false
            },
            xaxis: {
                labels: {
                    show: false
                },
                axisTicks: {
                    show: false
                },
                categories: [''],
                max: (this.totalStorageUsage / this.maxStorageCapacity) < 0.10 ? this.totalStorageUsage * 10 : this.maxStorageCapacity,
                tickAmount: 1
            },
            yaxis: {
                title: {
                    text: undefined
                },
            },
            fill: {
                opacity: 1
            },
            tooltip: {
                y: {
                    formatter: (val) => {
                        // val is a number that represents KB. Show it as GB when possible (0.01) is the lowest format, or else in MB
                        // first 'replace' is to remove unnecessary zeros after dot (XX.00). second 'replace' is to format number with commas (X,XXX)
                        if (val > 1000 * 1000 * 1000 * 1000) { // from 1000GB and above - display as 1TB
                            return Number(val/(1000 * 1000 * 1000 * 1000)).toLocaleString('en-US', {minimumFractionDigits: 0, maximumFractionDigits: 2}) + ' TB';
                        }
                        else if (val > 100 * 1000 * 1000) {  // from 100MB and above - display as 0.1GB
                            return Number(val/(1000 * 1000 * 1000)).toLocaleString('en-US', {minimumFractionDigits: 0, maximumFractionDigits: 2}) + ' GB';
                        }
                        else { // default - display in MB
                            return Number(val/(1000 * 1000)).toLocaleString('en-US', {minimumFractionDigits: 0, maximumFractionDigits: 2}) + ' MB';
                        }
                    }
                }
            },
            legend: {
                position: 'bottom',
                horizontalAlign: 'center',
                showForSingleSeries: true,
                showForZeroSeries: false,
            }
        };
    }


	getEmailTraceStats() {
		this.getEmailTraceStatsInProcess = true;

		this.emailTraceEmails = [];

		const params: any = {type: this.dic.CONSTANTS.dashboardTypes.emailsTrace, period: this.period.value};
		this.getUsage(params, (err, response) => {
			if (err) {
				this.getEmailTraceStatsInProcess = false;
				return;
			}

			this.emailTraceEmails = response.logs;

			this.usageData.emailTrace = this.parseEmailTraceData(this.emailTraceEmails, {period: this.period.value});
			this.buildEmailTraceLastActivity();
			this.getEmailTraceStatsInProcess = false;

			this.prepareEmailTraceGraph(false);
			if (response.scrollId) {
				this.getEmailTraceStatsBatch(this.period, response.scrollId);
			}
		});
	}

	getEmailTraceStatsBatch = (periodObj, scrollId) => {
		const params = {type: this.dic.CONSTANTS.dashboardTypes.emailsTrace, period: periodObj.value, scrollId};
		this.rs.getUsage(params).then((response) => {

			if (response?.logs?.length) {
				this.emailTraceEmails = this.emailTraceEmails.concat(response.logs);
				this.usageData.emailTrace = this.parseEmailTraceData(this.emailTraceEmails, {period: periodObj.value});
				this.buildEmailTraceLastActivity();
				this.prepareEmailTraceGraph(true);
			}

			this.getEmailTraceStatsInProcess = false;

			if (response.scrollId) {
				this.getEmailTraceStatsBatch(periodObj, response.scrollId);
			}

		}, () => {
			this.initTrendsProcessParams('emailTrace');
		});
	}

	parseEmailTraceData(emails, currentQuery) {
		let trendsPeriod: any = this.outboundTrendsService.getTrendsPeriodForGraphs(currentQuery);

		const emailsTrends = {
			total: emails.length,
			inbound: {
				total: 0,
				completed: 0,
				quarantined: 0,
				inProcess: 0,
				failed: 0,
				// CC: created date of the most recent email per status
				lastCompleted: null,
				lastQuarantined: null,
				lastInProcess: null,
				lastFailed: null
			},
			outbound: {
				total: 0,
				completed: 0,
				quarantined: 0,
				inProcess: 0,
				failed: 0,
				// CC: created date of the most recent email per status
				lastCompleted: null,
				lastQuarantined: null,
				lastInProcess: null,
				lastFailed: null
			},
			labels: [],
			data: [[], []],
			series: ['Inbound', 'Outbound'],
			// CC: most recent email in the period - shown as "last email seen ..." on the card
			lastEmailAt: null,
			lastEmailAgo: '',
		};

		if (!emails?.length) {
			return emailsTrends;
		}

		// @ts-ignore
		emails.sort((a, b) => new Date(a._source.created) - new Date(b._source.created));

		emailsTrends.lastEmailAt = emails[emails.length - 1]._source.created;
		emailsTrends.lastEmailAgo = moment(emailsTrends.lastEmailAt).fromNow();

		// CC: fixed-size time buckets, zero-filled from period start to now - shows flow continuity (gaps = no traffic) instead of one bar per day
		// CC: bucket sizes per period (day 30m, 3 days 2h, week 4h, month 12h). lastDay was 5m, which produced ~288 points -
		// CC: too dense to read (a comb of hairline spikes). 30m keeps ~48 points, so the curve stays legible
		const bucketMinutes = ({lastDay: 30, last3Days: 120, lastWeek: 240, lastMonth: 720})[trendsPeriod] || 720;
		const periodDays = ({lastDay: 1, last3Days: 3, lastWeek: 7, lastMonth: 30})[trendsPeriod] || 30;
		const bucketMs = bucketMinutes * 60 * 1000;
		const rollingStart = Math.floor((Date.now() - periodDays * 24 * 60 * 60 * 1000) / bucketMs) * bucketMs;
		// CC: the server period filter can span wider than a rolling window (calendar days) - extend the axis back to the earliest email (up to one extra period) so every counted email is plotted
		const earliestCreated = new Date(emails[0]._source.created).getTime();
		const bucketsStart = Math.max(Math.min(rollingStart, Math.floor(earliestCreated / bucketMs) * bucketMs), rollingStart - periodDays * 24 * 60 * 60 * 1000);
		const bucketsCount = Math.ceil((Date.now() - bucketsStart) / bucketMs);
		const inboundBuckets = new Array(bucketsCount).fill(0);
		const outboundBuckets = new Array(bucketsCount).fill(0);

		emails.forEach((emailObj) => {
			emailObj.direction = emailObj._source.direction;
			emailObj.created = emailObj._source.created;
			emailObj.status = emailObj._source.status;

			const directionStats = emailObj.direction === 'inbound' ? emailsTrends.inbound :
				emailObj.direction === 'outbound' ? emailsTrends.outbound : null;
			if (!directionStats) {
				return;
			}

			directionStats.total++;
			// CC: emails are sorted ascending by created, so the last write per status is the most recent email
			switch (emailObj.status) {
				case 'Completed':
					directionStats.completed++;
					directionStats.lastCompleted = emailObj.created;
					break;

				case 'Quarantined':
					directionStats.quarantined++;
					directionStats.lastQuarantined = emailObj.created;
					break;

				case 'In Process':
					directionStats.inProcess++;
					directionStats.lastInProcess = emailObj.created;
					break;

				case 'Failed':
					directionStats.failed++;
					directionStats.lastFailed = emailObj.created;
					break;

				default:
					console.error(emailObj.status);
			}

			const bucketIndex = Math.floor((new Date(emailObj.created).getTime() - bucketsStart) / bucketMs);
			if (bucketIndex >= 0 && bucketIndex < bucketsCount) {
				(emailObj.direction === 'inbound' ? inboundBuckets : outboundBuckets)[bucketIndex]++;
			}
		});

		// CC: drop leading empty buckets - a server window wider than the rolling period can pad the axis with an empty first day
		let firstBucketIndex = 0;
		while (firstBucketIndex < bucketsCount - 1 && !inboundBuckets[firstBucketIndex] && !outboundBuckets[firstBucketIndex]) {
			firstBucketIndex++;
		}

		for (let i = firstBucketIndex; i < bucketsCount; i++) {
			const bucketMoment = moment(bucketsStart + i * bucketMs);
			// CC: label granularity follows the bucket: day "HH:mm", 3 days/week "ddd HH:mm", month "MM/DD HH:mm"
			emailsTrends.labels.push(bucketMinutes >= 1440 ? bucketMoment.format('MM/DD') :
				periodDays >= 30 ? bucketMoment.format('MM/DD HH:mm') :
				periodDays > 1 ? bucketMoment.format('ddd HH:mm') : bucketMoment.format('HH:mm'));
		}
		emailsTrends.data = [inboundBuckets.slice(firstBucketIndex), outboundBuckets.slice(firstBucketIndex)];

		return emailsTrends;
	}


	getOutboundStats(isReload) {
        this.getOutboundStatsInProcess = true;

		const params: any = {type: this.dic.CONSTANTS.dashboardTypes.outbound, period: this.period.value};
		if (isReload) {
			if (this.isAdmin) {
				this.getOutboundTrendsBatch(this.period);
				return;
			}
			params.skipCache = true;
		}
		this.getUsage(params, (err, outboundUsageData) => {
			if (err) {
				this.getOutboundStatsInProcess = false;
				return;
			}
			if (outboundUsageData.created) {
				this.usageData.outbound = outboundUsageData;
				this.prepareOutboundTrendsGraph(false);
				this.prepareOutboundRulesGraph(false);
				this.initTrendsProcessParams('outbound');
				return;
			}

			if (this.isAdmin) {
				this.getOutboundTrendsBatch(this.period);
			}
			else {
				this.initTrendsProcessParams('outbound');
			}
        });
    }

	getOutboundTrendsBatch = (periodObj) => {
		const params = {period: periodObj.value, size: this.batchSize};
		this.rs.getOutboundTrendsBatch(params).then((response) => {

			this.outboundEmails = response.emails;
			this.gs.userInfo.internalDomains = response.domains;
			this.gs.userInfo.rules = response.rules;

			this.getOutboundStatsInProcess = false;
			this.showAbortLoadingEmailsLabel = true;

			this.usageData.outbound = this.outboundTrendsService.parseEmailSentData(this.userInfo, this.outboundEmails, {period: periodObj.value});

			this.prepareOutboundTrendsGraph(false);
			this.prepareOutboundRulesGraph(false);

			this.getNextOutboundEmailsBatch(periodObj, response.lastCreated, () => {});

		}, () => {
			this.initTrendsProcessParams('outbound');
		});
	}

	getNextOutboundEmailsBatch = (periodObj, lastCreated, cb) => {
		if (!lastCreated) {
			this.initTrendsProcessParams('outbound');
			return cb();
		}

		if (this.abortLoadingFlag) {
			this.initTrendsProcessParams('outbound');
			return cb();
		}
		this.batchInProcess = true;

		const params = {period: periodObj.value, lastCreated, size: this.batchSize};
		this.rs.getOutboundTrendsBatch(params).then((response) => {
			if (response.emails?.length) {
				this.outboundEmails = this.outboundEmails.concat(response.emails);
				this.usageData.outbound = this.outboundTrendsService.parseEmailSentData(this.userInfo, this.outboundEmails, {period: periodObj.value});
				this.prepareOutboundTrendsGraph(true);
				this.prepareOutboundRulesGraph(true);
			}
			this.getNextOutboundEmailsBatch(periodObj, response.lastCreated, cb);
		});
	}

	prepareEmailTraceGraph = (isUpdate) => {
		const series = [];
		this.usageData.emailTrace?.series.forEach((categoryName, index) => {
			series.push({
				name: categoryName,
				data: this.usageData.emailTrace.data[index]
			});
		});

		if (isUpdate && this.emailTraceChart && this.emailTraceTrendsChartOptions?.series?.length &&
			this.gs.areArraysEqual(this.usageData.emailTrace.labels, this.emailTraceTrendsChartOptions.xaxis.categories)) {
			this.emailTraceChart.updateSeries(series, true);
			return;
		}

		const chartType = this.usageData.emailTrace?.labels?.length === 1 ? "bar" : "area";
		const chartColors = ['#1a4d99', '#2a9d38'];
		const chartStyle = buildTrendsChartStyle(chartType, chartColors);

		this.emailTraceTrendsChartOptions = {
			series: series,
			chart: {
				type: chartType,
				height: '100%',
				toolbar: {
					show: false
				},
			},

			colors: chartColors,
			dataLabels: {
				enabled: false
			},
			stroke: chartStyle.stroke,
			xaxis: {
				tickAmount: 4, // Set the maximum number of ticks (labels) to be displayed on the x-axis
				categories: this.usageData.emailTrace?.labels,
				// CC: one tick per bucket rendered as a solid comb under the chart - the labels above are enough
				axisTicks: {
					show: false
				}
			},
			yaxis: {
				title: {
					text: 'Emails'
				}
			},
			fill: chartStyle.fill,
			tooltip: {
				y: {
					formatter: (val) => {
						return val + ' emails';
					}
				}
			}
		};
	};

	prepareOutboundTrendsGraph = (isUpdate) => {
		const series = [];
		this.usageData.outbound.general?.series.forEach((categoryName, index) => {
			series.push({
				name: categoryName,
				data: this.usageData.outbound.general.data[index]
			});
		});

		if (isUpdate && this.outboundEmailsChart && this.outboundTrendsChartOptions?.series?.length &&
			this.gs.areArraysEqual(this.usageData.outbound.general.labels, this.outboundTrendsChartOptions.xaxis.categories)) {
			this.outboundEmailsChart.updateSeries(series, true);
			return;
		}

		const chartType = this.usageData.outbound.general?.labels?.length === 1 ? "bar" : "area";
		const chartColors = ['#1a4d99', '#2a9d38', '#d17e38'];
		const chartStyle = buildTrendsChartStyle(chartType, chartColors);

		this.outboundTrendsChartOptions = {
			series: series,
			chart: {
				type: chartType,
				height: '100%',
				toolbar: {
					show: false
				},
			},

			colors: chartColors,
			dataLabels: {
				enabled: false
			},
			stroke: chartStyle.stroke,
			xaxis: {
				tickAmount: 4, // Set the maximum number of ticks (labels) to be displayed on the x-axis
				categories: this.usageData.outbound.general?.labels,
				axisTicks: {
					show: false
				}
			},
			yaxis: {
				title: {
					text: 'Emails'
				}
			},
			fill: chartStyle.fill,
			tooltip: {
				y: {
					formatter: (val) => {
						return val + ' emails';
					}
				}
			}
		};
	};


	prepareOutboundRulesGraph = (isUpdate) => {
		this.usageData.outbound.rules.total = this.usageData.outbound.rules.data.reduce((a, b) => a + b, 0);

		if (isUpdate && this.outboundRulesChart && this.outboundRulesChartOptions?.series?.length && this.gs.areArraysEqual(this.outboundRulesChartOptions.labels, this.usageData.outbound.rules.labels)) {
			this.outboundRulesChart.updateSeries(this.usageData.outbound.rules.data, true);
			return;
		}

		this.outboundRulesChartOptions = {
			series: this.usageData.outbound.rules.data,
			chart: {
				type: 'donut',
				events: {
					dataPointSelection: (event, chartContext, config) => {
						if (!event || !config) {
							return;
						}

						this.ruleUsagePopupData = {
							show: true,
							period: this.period,
							ruleObj: {
								_id: this.usageData.outbound.rules.rulesIds[config.dataPointIndex]
								, name: this.usageData.outbound.rules.labels[config.dataPointIndex]
							}
						};
					}
				}
			},
			plotOptions: {
				pie: {
					donut: {
						size: '52%'
					}
				}
			},
			dataLabels: {
				enabled: true,
				formatter: (val, opt) => {
					return opt.w.globals.series[opt.seriesIndex];
				}
			},
			labels: this.usageData.outbound.rules.labels,
			tooltip: {
				y: {
					formatter: (val) => {
						return val + ' emails';
					}
				}
			}
		}
	};


	getAccountCompromisedStats(periodObj) {
		if (!this.userInfo.plan.account_compromised?.enabled) {
			return;
		}
        this.getCompromisedStatsInProcess = true;

		const params = {type: this.dic.CONSTANTS.dashboardTypes.accountCompromised, period: periodObj.value};
		this.getUsage(params, (err, usageData) => {
			if (err) {
				this.getCompromisedStatsInProcess = false;
				return;
			}
			this.usageData.compromisedStats = usageData && usageData.accountCompromised;

            // compromised chart
            this.compromisedIncidentsChartOptions = null;
            if (usageData && usageData.accountCompromised) {

                this.prepareUsersLocationInfo(usageData.accountCompromised.locations || null);

                if (usageData.accountCompromised.incidentsTypes && !_.isEmpty(usageData.accountCompromised.incidentsTypes)) {

                    const sortedIncidentTypes = sortItems(usageData.accountCompromised.incidentsTypes);
                    usageData.accountCompromised.incidentsTypesGraph = {data: [], labels: []};
                    sortedIncidentTypes.forEach((type) => {
                        usageData.accountCompromised.incidentsTypesGraph.data.push(usageData.accountCompromised.incidentsTypes[type]);
                        usageData.accountCompromised.incidentsTypesGraph.labels.push(this.dic.CONSTANTS.accountCompromisedIncidentTypes[type].name);
                    });

                    this.compromisedIncidentsChartOptions = {
                        series: [{
                            name: 'Incidents',
                            data: usageData.accountCompromised.incidentsTypesGraph.data
                        }],
                        chart: {
                            type: 'bar',
                            height: '100%',
                            toolbar: {
                                show: false
                            },
                        },
                        plotOptions: {
                            bar: {
                                borderRadius: 5,
                                horizontal: true,
                                barHeight: this.gs.getOptimalBarWidth(Object.values(usageData.accountCompromised.incidentsTypes).length) + '%',
                            },
                        },
                        dataLabels: {
                            enabled: true
                        },
                        stroke: {
                            show: true,
                            width: 4,
                            colors: ['transparent']
                        },
                        xaxis: {
                            categories: usageData.accountCompromised.incidentsTypesGraph.labels,
                            // CC: force whole-number ticks (no decimals) on the value axis
                            min: 0,
                            max: Math.max(...usageData.accountCompromised.incidentsTypesGraph.data, 1),
                            tickAmount: Math.max(...usageData.accountCompromised.incidentsTypesGraph.data, 1),
                            labels: {
                                formatter: (val) => {
                                    // CC: hide half-step ticks so only whole numbers show (no duplicates)
                                    const num = Number(val);
                                    return Number.isInteger(num) ? num.toString() : '';
                                }
                            }
                        },
                        fill: {
                            opacity: 1
                        },
                        tooltip: {
                            y: {
                                formatter: (val) => {
                                    return val;
                                }
                            }
                        }
                    };
                }
            }

            this.getCompromisedStatsInProcess = false;
        });
    };

    prepareUsersLocationInfo(locationsObj) {
        this.compromisedLocations = null;
        this.compromisedLayers = null;

        if (!locationsObj) {
            return;
        }

        this.compromisedLocations = {last: []};
		let boundsLast = [];
        let maxCount = 0;
        if (locationsObj.allLastLocations.length) {
            locationsObj.allLastLocations.forEach((locationObj) => {
                if (locationObj.location.ll.length === 2) {
					const marker = {
						title: locationObj.email,
						icon: this.gs.leafletDefaultIcon,
						lat: locationObj.location.ll[0],
						lng: locationObj.location.ll[1],
						count: locationObj.count,
						draggable: false
					};

                    if (marker.count > maxCount) {
                        maxCount = marker.count;
                    }
					boundsLast.push([locationObj.location.ll[0],locationObj.location.ll[1]]);

                    this.compromisedLocations.last.push(marker);
                }
            });
			const centroidLast = boundsLast.length > 0 ? new L.LatLngBounds(boundsLast).getCenter() : { lat: 0, lng: 0 };
			this.leafletCenter.last = {
				lat: centroidLast.lat,
				lng: centroidLast.lng,
				zoom: 2
			};
		}

        const baseLayers = {
			osm: {
				name: 'OpenStreetMap',
				//http://otile{s}.mqcdn.com/tiles/1.0.0/map/{z}/{x}/{y}.jpg
				url: 'https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png',
				type: 'xyz'
			}
        };
        this.compromisedLayers = {last: {baseLayers}};

		maxCount = Math.max(...this.compromisedLocations.last.map(itm => itm.count)) + 1;
		this.compromisedLayers.last.overlays = {
			heatmap: {
				name: 'Last Heat Map',
				type: 'webGLHeatmap',
				data: this.compromisedLocations.last.map(itm => ([itm.lat, itm.lng, 1 - itm.count / maxCount])),  //intense can be always 1
				visible: true
			}
		};
    }

    getInboundStats(isReload) {
        this.getInboundStatsInProcess = true;

		const params: any = {type: this.dic.CONSTANTS.dashboardTypes.inbound, period: this.period.value};
		if (isReload) {
			if (this.isAdmin) {
				this.getInboundTrendsBatch(this.period);
				return;
			}
			params.skipCache = true;
		}
		this.rs.getUsage(params).then(inboundUsageData => {
			if (inboundUsageData.created) {
				this.usageData.inbound = inboundUsageData;
				this.prepareInboundTrendsGraph(false);
				this.prepareInboundDetectionTypeGraph(false);
				this.initTrendsProcessParams('inbound');
				return;
			}
			if (this.isAdmin) {
				this.getInboundTrendsBatch(this.period);
			}
			else {
				this.initTrendsProcessParams('inbound');
			}
        }, () => {
			this.getInboundStatsInProcess = false;
		});
    };

	getInboundTrendsBatch = (periodObj) => {
		const params = {period: periodObj.value, size: this.batchSize};
		this.rs.getInboundTrendsBatch(params).then((response) => {

			this.inboundEmails = response.emails;

			this.getInboundStatsInProcess = false;
			this.showAbortLoadingEmailsLabel = true;

			this.usageData.inbound = this.inboundTrendsService.parseTrendsData(this.userInfo, this.inboundEmails, {period: periodObj.value});

			this.prepareInboundTrendsGraph(false);
			this.prepareInboundDetectionTypeGraph(false);

			this.getNextInboundEmailsBatch(periodObj, response.lastCreated, () => {});

		}, () => {
			this.initTrendsProcessParams('inbound');
		});
	}

	getNextInboundEmailsBatch = (periodObj, lastCreated, cb) => {
		if (!lastCreated) {
			this.initTrendsProcessParams('inbound');
			return cb();
		}

		if (this.abortLoadingFlag) {
			this.initTrendsProcessParams('inbound');
			return cb();
		}
		this.batchInProcess = true;

		const params = {period: periodObj.value, lastCreated, size: this.batchSize};
		this.rs.getInboundTrendsBatch(params).then((response) => {
			if (response.emails?.length) {
				this.inboundEmails = this.inboundEmails.concat(response.emails);
				this.usageData.inbound = this.inboundTrendsService.parseTrendsData(this.userInfo, this.inboundEmails, {period: periodObj.value});
				this.prepareInboundTrendsGraph(true);
				this.prepareInboundDetectionTypeGraph(true);
			}
			this.getNextInboundEmailsBatch(periodObj, response.lastCreated, cb);
		});
	}

	initTrendsProcessParams = (type) => {
		this.batchInProcess = false;
		this.showAbortLoadingEmailsLabel = false;

		switch (type) {
			case 'inbound':
				this.getInboundStatsInProcess = false;
				break;

			case 'outbound':
				this.getOutboundStatsInProcess = false;
				break;

			case 'emailTrace':
				this.getEmailTraceStatsInProcess = false;
				break;
		}
	}

	abortLoadingEmails = () => {
		this.abortLoadingFlag = true;
		this.showAbortLoadingEmailsLabel = false;
		this.getInboundStatsInProcess = false;
		this.getOutboundStatsInProcess = false;
	}

	prepareInboundTrendsGraph = (isUpdate) => {
		const series = [];
		if (this.usageData.inbound.inboundStats.labels.length) {
			this.usageData.inbound.inboundStats?.series?.forEach((categoryName, index) => {
				series.push({
					name: categoryName,
					data: this.usageData.inbound.inboundStats.data[index]
				});
			});
		}

		if (isUpdate && this.inboundTrendsChart && this.inboundTrendsChartOptions?.series?.length &&
			this.gs.areArraysEqual(this.usageData.inbound.inboundStats.labels, this.inboundTrendsChartOptions.xaxis.categories)) {
			this.inboundTrendsChart.updateSeries(series, true);
			return;
		}

		const chartType = this.usageData.inbound.inboundStats.labels?.length === 1 ? "bar" : "area";
		const chartColors = ['#f1122d', '#e56f39', '#f5cb0d', '#bbbbbb', '#bbbbbb'];
		const chartStyle = buildTrendsChartStyle(chartType, chartColors);

		this.inboundTrendsChartOptions = {
			series: series,
			chart: {
				type: chartType,
				height: '100%',
				toolbar: {
					show: false
				},
				events: {
					dataPointSelection: (event, chartContext, config) => {
						if (!event || !config || !this.isAdmin) {
							return;
						}

						const queryData = {
							filters: {
								category: [series[config.seriesIndex].name]
							},
							period: this.period
						};

						this.router.navigate([this.dic.CONSTANTS.appStates.adminInbound, this.dic.CONSTANTS.adminPages.inbound.quarantined], {state: {data: queryData}});
					}
				}
			},
			colors: chartColors,
			dataLabels: {
				enabled: false
			},
			stroke: chartStyle.stroke,
			xaxis: {
				tickAmount: 4, // Set the maximum number of ticks (labels) to be displayed on the x-axis
				categories: this.usageData.inbound.inboundStats.labels,
				axisTicks: {
					show: false
				}
			},
			yaxis: {
				title: {
					text: 'Threats'
				}
			},
			fill: chartStyle.fill,
			tooltip: {
				y: {
					formatter: (val) => {
						return val + ' threats';
					}
				}
			}
		};
	}

	prepareInboundDetectionTypeGraph = (isUpdate) => {
		this.usageData.inbound.detectionType.total = _.sum(this.usageData.inbound.detectionType.data);

		if (isUpdate && this.threatDetectionTypeChart && this.detectionTypeChartOptions?.series?.length &&
			this.gs.areArraysEqual(this.usageData.inbound.detectionType.labels, this.detectionTypeChartOptions.labels)) {
			this.threatDetectionTypeChart.updateSeries(this.usageData.inbound.detectionType.data, true);
			return;
		}

		this.detectionTypeChartOptions = {
			series: this.usageData.inbound.detectionType.data,
			chart: {
				type: 'donut',
				animations: {
					enabled: true,
				},
				events: {
					dataPointSelection: (event, chartContext, config) => {
						if (!event || !config) {
							return;
						}

						const subCategory = this.usageData.inbound.detectionType.labels[config.dataPointIndex];
						if (subCategory === 'Misc') {
							return;
						}
						const options = {
							period: this.period,
							sub_category: [subCategory]
						};

						// Determine the path based on isAdmin
						const path = this.isAdmin ?
							[this.dic.CONSTANTS.appStates.adminInbound, this.dic.CONSTANTS.adminPages.inbound.quarantined] :
							[this.dic.CONSTANTS.appStates.adminInbound, this.dic.CONSTANTS.adminPages.inbound.userQuarantinedInboundConf];

						this.router.navigate(path, {state: {data: options}});
					}
				},
			},
			plotOptions: {
				pie: {
					donut: {
						size: '52%',
					}
				}
			},
			dataLabels: {
				enabled: true,
				formatter:  (val, opt) => {
					return opt.w.globals.series[opt.seriesIndex];
				}
			},
			colors: ['#d92e1d', '#e09096', '#a94caa', '#ff9f67', '#fad07d', '#77a380'],
			labels: this.usageData.inbound.detectionType.labels,
			tooltip: {
				y: {
					formatter:  (val) => {
						return val + ' threats';
					}
				}
			}
		};
	}

    openLocation(ll) {
        this.gs.openLocation(ll);
    };

    goToAuditLogs(type) {
        switch (type) {
			case 'Outbound':
				this.router.navigate([this.dic.CONSTANTS.appStates.adminOutbound, this.dic.CONSTANTS.adminPages.outbound.auditLog]);
				break;

			case 'Inbound':
				this.router.navigate([this.dic.CONSTANTS.appStates.adminInbound, this.dic.CONSTANTS.adminPages.inbound.auditLog]);
				break;

            case 'Archive':
				this.router.navigate([this.dic.CONSTANTS.appStates.archive, this.dic.CONSTANTS.archivePages.auditLog]);
                break;

            case 'Account Compromised':
				this.router.navigate([this.dic.CONSTANTS.appStates.accountCompromised, this.dic.CONSTANTS.accountCompromisedPages.auditLog]);
                break;

			case 'Domain':
				this.router.navigate([this.dic.CONSTANTS.appStates.domainProtection, this.dic.CONSTANTS.adminPages.domainProtection.auditLog]);
				break;

			case 'Collaboration Protection':
				this.router.navigate([this.dic.CONSTANTS.appStates.collaborationProtection, this.dic.CONSTANTS.adminPages.collaborationProtection.auditLog]);
				break;

			case 'Threat Simulation':
				this.router.navigate([this.dic.CONSTANTS.appStates.threatSimulation, this.dic.CONSTANTS.adminPages.threatSimulation.auditLog]);
				break;
        }
    };

    goToMyPlan() {
		this.router.navigate([this.dic.CONSTANTS.appStates.accountDetails, this.dic.CONSTANTS.accountDetailsPages.myPlan]);
    };

    inboundDetails = () => {
        window.open('https://trustifi.com/inbound-shield','_blank');
    };

    outboundDetails = () => {
        window.open('https://trustifi.com/outbound-shield/','_blank');
    };

    accountDetectionDetails = () => {
        window.open('https://trustifi.com/account-compromise-detection/','_blank');
    };

	quickAccessNavigate = (url) => {
		this.router.navigate([url]);
	}

	buildEmailTraceLastActivity() {
		const emailTrace = this.usageData?.emailTrace;
		this.emailTraceLastActivity = {
			inbound: {
				lastCompleted: emailTrace?.inbound?.lastCompleted ? moment(emailTrace.inbound.lastCompleted).fromNow() : null,
				lastQuarantined: emailTrace?.inbound?.lastQuarantined ? moment(emailTrace.inbound.lastQuarantined).fromNow() : null,
				lastInProcess: emailTrace?.inbound?.lastInProcess ? moment(emailTrace.inbound.lastInProcess).fromNow() : null,
				lastFailed: emailTrace?.inbound?.lastFailed ? moment(emailTrace.inbound.lastFailed).fromNow() : null,
			},
			outbound: {
				lastCompleted: emailTrace?.outbound?.lastCompleted ? moment(emailTrace.outbound.lastCompleted).fromNow() : null,
				lastQuarantined: emailTrace?.outbound?.lastQuarantined ? moment(emailTrace.outbound.lastQuarantined).fromNow() : null,
				lastInProcess: emailTrace?.outbound?.lastInProcess ? moment(emailTrace.outbound.lastInProcess).fromNow() : null,
				lastFailed: emailTrace?.outbound?.lastFailed ? moment(emailTrace.outbound.lastFailed).fromNow() : null,
			}
		};
	}

	goToEmailTrace = (direction, status) => {
		const queryData = {
			// CC: no status = open the direction's entire traffic. The email trace page preselects its status filter from this
			// CC: list, so "all" has to be spelled out - taken from email-trace.component.ts -> initEmailTraceFilters
			status: status ? [status] : ['Completed', 'Quarantined', 'In Process', 'Failed'],
			period: this.period
		};

		const path = direction === 'outbound' ?
			[this.dic.CONSTANTS.appStates.adminOutbound, this.dic.CONSTANTS.adminPages.outbound.emailTrace] :
			[this.dic.CONSTANTS.appStates.adminInbound, this.dic.CONSTANTS.adminPages.inbound.emailTrace];

		this.router.navigate(path, {state: {data: queryData}});
	}
}

function sortItems(list) {
    return Object.keys(list).sort((a,b) => {return list[b] - list[a]});
}

// CC: shared stroke/fill for the dashboard trends charts.
// CC: The area charts drew a 4px 'transparent' stroke (the ApexCharts trick for spacing between BARS), which cut a gap
// CC: around every point and left the series looking washed out. Area now gets a solid line over a fading gradient;
// CC: bar keeps the transparent stroke, where it is the correct spacing behavior.
function buildTrendsChartStyle(chartType, colors) {
	if (chartType === 'bar') {
		return {
			stroke: {
				show: true,
				width: 4,
				colors: ['transparent']
			},
			fill: {
				opacity: 1
			}
		};
	}

	return {
		stroke: {
			show: true,
			width: 2.5,
			curve: 'straight',
			colors: colors
		},
		fill: {
			type: 'gradient',
			gradient: {
				// CC: low shadeIntensity keeps the fill on the series hue instead of washing it toward white
				shadeIntensity: 0.35,
				opacityFrom: 0.75,
				opacityTo: 0.1,
				stops: [0, 100]
			}
		}
	};
}
